import { Injectable } from '@angular/core';
import { AppComponent } from '../../app.component';
import { CommonService } from '../../services/commonService';
import { Constants } from 'src/app/modal/ProjConstants.models';
import * as XLSX from 'xlsx';
import { UserInputService } from '../../services/userInput.service';
import { CleanUpVinService } from '../../services/cleanUpVin.service';
import _ from 'lodash';
import { DAO, vehicleDetails, VehicleModel } from '../../modal/DAO';
import { VehicleTemplateConstants } from '../../modal/VehicleTemplateConstants.models';

@Injectable({
  providedIn: 'any'
})

export class VehicleUploadService {

    constructor(private commonService: CommonService, public appComponent: AppComponent, private userInputService: UserInputService, public dao: DAO) { }

    public validateTemplateHeaders(puSheet: any, trailerSheet: any, version : string ): boolean {
        
        if(!!!puSheet || !!!trailerSheet) {
            return false;
        }
        var powerUnitsTemplateHeaders1 = XLSX.utils.sheet_to_json(puSheet, { header: 1 })[0];
        var powerUnitsTemplateHeaders2 = XLSX.utils.sheet_to_json(puSheet, { header: 1 })[1];
        var trailersTemplateHeaders = XLSX.utils.sheet_to_json(trailerSheet, { header: 1 })[0];

        if (!powerUnitsTemplateHeaders1[0] || powerUnitsTemplateHeaders1[0] != 'Please use Trailer tab to upload Trailer details') {
            return false;
        }

        let expectedPowerUnitHeaders = VehicleTemplateConstants.VEHICLE_TEMPLATE_HEADERS[version].puMap;
        let expectedTrailerHeaders = VehicleTemplateConstants.VEHICLE_TEMPLATE_HEADERS[version].trMap;        
        
        // validate power unit headers
        const isValidPowerUnitHeader = this.validateHeader(powerUnitsTemplateHeaders2, expectedPowerUnitHeaders);
        // validate trailer headers
        const isValidTrailerHeader = this.validateHeader(trailersTemplateHeaders, expectedTrailerHeaders);
        
        return isValidPowerUnitHeader && isValidTrailerHeader;
    }

    private validateHeader(headers: any, expectedHeaders:  Map<number, string>): boolean {
        for(const [index, expectedHeader] of expectedHeaders.entries()){
            if(!!!expectedHeader){
                continue;
            }
            if(!!!headers[index] || headers[index] != expectedHeader){
                return false;
            }
        }
        return true;
    }

    private getLastIndex(valueList: any, group: string): number {
        let lastTrailerIndex = 0;  
        let data = this.dao.vehicleModel.vehicleDefault;
        console.info("valueList", typeof(valueList));
        console.info("data", typeof(data));
        valueList.forEach((trailer, index) => {
                lastTrailerIndex = index + 1;
            });

        return lastTrailerIndex;
    }


    // upload Power Unit details from excel to this.dao

    public uploadingPowerUnits(version: string, excelPowerUnits: any, vehicleModel: VehicleModel): boolean {
        let pwValueIndexMap = VehicleTemplateConstants.VEHICLE_TEMPLATE_VALUE_MAP[version].PowerUnit;

        if(!!!pwValueIndexMap || !!!excelPowerUnits){
            return false;
        }
        for (var row = 2; row <= excelPowerUnits.length - 1; row++) {
            var lastVehicleIndex = this.getLastIndex(vehicleModel.VehiclesList, 'VEH-');
            let tempVehicle = _.cloneDeep(vehicleModel.vehicleDefault);
            let excelPowerUnitRow = excelPowerUnits[row];
            // 1st form
            tempVehicle.vehicleYear.answer = this.getAndSetValidYear(excelPowerUnitRow[pwValueIndexMap.Year]);
            tempVehicle.vehicleMake.answer = this.getAndSetValidString(excelPowerUnitRow[pwValueIndexMap.Make]);
            tempVehicle.vehicleModel.answer = this.getAndSetValidString(excelPowerUnitRow[pwValueIndexMap.Model]);
            tempVehicle.vehicleVin.answer = !!excelPowerUnitRow[pwValueIndexMap.VIN] ? CleanUpVinService.cleanVin(excelPowerUnitRow[pwValueIndexMap.VIN]) : "";
            // 2nd form 
            tempVehicle.vehicleIsCorrectGaragingAddress.answer = this.getValidRadiobuttonAnswerFromExcel(excelPowerUnitRow[pwValueIndexMap.IsCorrectGaraging]);
            tempVehicle.vehicleSize.answer = this.getValidDropdownAnswerFromExcel('vehicleSize', excelPowerUnitRow[pwValueIndexMap.VehicleSize], this.dao);
            tempVehicle.vehicleBodyType.answer = this.getValidDropdownAnswerFromExcel('vehicleBodyType', excelPowerUnitRow[pwValueIndexMap.BodyType], this.dao);
            tempVehicle.vehicleSecondaryClass.answer = this.getValidDropdownAnswerFromExcel('vehicleSecondaryClass', excelPowerUnitRow[pwValueIndexMap.SecondaryClass], this.dao);
            tempVehicle.vehicleTotalMilesUpto50.answer = isNaN(excelPowerUnitRow[pwValueIndexMap.TotalMilesUpto50]) ? "" : excelPowerUnitRow[pwValueIndexMap.TotalMilesUpto50];
            tempVehicle.vehicleTotalMilesUpto200.answer = isNaN(excelPowerUnitRow[pwValueIndexMap.TotalMilesUpto200]) ? "" : excelPowerUnitRow[pwValueIndexMap.TotalMilesUpto200];
            
            if(version == Constants.CurrentVehicleExcelTemplateVersion){
                tempVehicle.farthestApplicableZonePercent.answer = this.getAndSetValidString(excelPowerUnitRow[pwValueIndexMap.FarthestApplicableZonePercent] || "");  
                if (!!tempVehicle.farthestApplicableZonePercent.answer && tempVehicle.farthestApplicableZonePercent.answer !== '0') {
                    tempVehicle.farthestToZone.answer = this.getValidDropdownAnswerFromExcel('farthestToZone', excelPowerUnitRow[pwValueIndexMap.FarthestToZone], this.dao); 
                }
                else {
                    tempVehicle.farthestToZone.answer = "";
                }
            }
            // 3rd form 
            const accounState = this.dao.DOTList.accountInfoQsnr.findQuestion("accountState")?.answer;            
            if (accounState != 'MI') {
                tempVehicle.vehicleCompOTCCoverage.answer = this.getValidRadiobuttonAnswerFromExcel(excelPowerUnitRow[pwValueIndexMap.CompOTCCoverage]);
                tempVehicle.vehicleComp.answer = tempVehicle.vehicleCompOTCCoverage.answer == 'Yes' ? this.getValidDropdownAnswerFromExcel('vehicleComp', excelPowerUnitRow[pwValueIndexMap.Comp], this.dao) : "";
                tempVehicle.vehicleCollCoverage.answer = this.getValidRadiobuttonAnswerFromExcel(excelPowerUnitRow[pwValueIndexMap.CollCoverage]);
                tempVehicle.vehicleColl.answer = tempVehicle.vehicleCollCoverage.answer == 'Yes' ? this.getValidDropdownAnswerFromExcel('vehicleColl', excelPowerUnitRow[pwValueIndexMap.Coll], this.dao) : "";
            }
            else {
                tempVehicle.vehicleCompOTCCoverage.answer = "";
                tempVehicle.vehicleCollCoverage.answer = "";
            }
            tempVehicle.vehicleStatedAmount.answer = isNaN(excelPowerUnitRow[pwValueIndexMap.StatedAmount]) ? "" : Math.round(excelPowerUnitRow[pwValueIndexMap.StatedAmount].trim());
            tempVehicle.vehicleCustomPartsParent.answer = this.getValidRadiobuttonAnswerFromExcel(excelPowerUnitRow[pwValueIndexMap.CustomParts]);
            tempVehicle.vehicleCustomAmount.answer = tempVehicle.vehicleCustomPartsParent.answer == 'Yes' ? (isNaN(excelPowerUnitRow[pwValueIndexMap.CustomAmount]) ? "" : Math.round(excelPowerUnitRow[pwValueIndexMap.CustomAmount].trim())) : "";
            tempVehicle.vehicleCustomDesc.answer = tempVehicle.vehicleCustomPartsParent.answer == 'Yes' ? excelPowerUnitRow[pwValueIndexMap.CustomDesc] : "";
            tempVehicle.vehicleAddInsuredOrLossPayee.answer = this.getValidRadiobuttonAnswerFromExcel(excelPowerUnitRow[pwValueIndexMap.AddInsuredOrLossPayee]);
            
            if ( this.dao.vehicleModel.VehiclesList.length > 0 && this.dao.vehicleModel.VehiclesList.every(item => item.isChecked)) {
                tempVehicle.isChecked = true;
            }
            Object.keys(tempVehicle).forEach(tempKey => {
                if (typeof (tempVehicle[tempKey]) == 'object') {
                    tempVehicle[tempKey].group = 'VEH-' + (lastVehicleIndex + 1);
                    if (tempVehicle[tempKey].questionOptions != null && tempVehicle[tempKey].questionOptions.length > 0) {
                        tempVehicle[tempKey].questionOptions = []; //empty question options to reduce payload size
                    }
                }
            });
            tempVehicle.interestList = [];
            if (tempVehicle.vehicleAddInsuredOrLossPayee.answer == 'Yes') {
                var vehicleInsuredOrLossPayee = { 'Type': '', 'Name': '', 'streetAddress': '', 'city': '', 'state': '', 'zip': '', 'loanNo': '' };
                tempVehicle.interestList.push(vehicleInsuredOrLossPayee);
            }
            tempVehicle.vehicleType.answer = '';
            this.dao.vehicleModel.VehiclesList.push(tempVehicle);
            this.dao.isTrailer = false;
        }
        return true;       
    }
    // upload trailer details from excel to this.dao 

    public uploadingTrailers(version: string, excelTrailers: any, vehicleModel: VehicleModel): boolean {
        let trailerValueMapForVersion =  VehicleTemplateConstants.VEHICLE_TEMPLATE_VALUE_MAP[version].Trailer;
        if(!!!trailerValueMapForVersion || !!!excelTrailers){
            return false;
        }
        for (var row = 1; row <= excelTrailers.length - 1; row++) {
            var lastTrailerIndex = this.getLastIndex(vehicleModel.trailerList, 'TRA-');
            let tempTrailer = _.cloneDeep(vehicleModel.vehicleDefault);
            let excelTrailerRow = excelTrailers[row];
            // 1st form
            tempTrailer.vehicleYear.answer = this.getAndSetValidYear(excelTrailerRow[trailerValueMapForVersion.Year]);
            tempTrailer.vehicleMake.answer = this.getAndSetValidString(excelTrailerRow[trailerValueMapForVersion.Make]);
            tempTrailer.vehicleModel.answer = this.getAndSetValidString(excelTrailerRow[trailerValueMapForVersion.Model]);
            tempTrailer.vehicleVin.answer = !!excelTrailerRow[trailerValueMapForVersion.VIN] ? CleanUpVinService.cleanVin(excelTrailerRow[trailerValueMapForVersion.VIN]) : "";
            // 2nd form 
            tempTrailer.vehicleIsCorrectGaragingAddress.answer = this.getValidRadiobuttonAnswerFromExcel(excelTrailerRow[trailerValueMapForVersion.IsCorrectGaraging]);
            tempTrailer.trailerSize.answer = this.getValidDropdownAnswerFromExcel('trailerSize', excelTrailerRow[trailerValueMapForVersion.TrailerSize], this.dao);
            tempTrailer.trailerBodyType.answer = this.getValidDropdownAnswerFromExcel('trailerBodyType', excelTrailerRow[trailerValueMapForVersion.TrailerBodyType], this.dao);
            tempTrailer.vehicleSecondaryClass.answer = this.getValidDropdownAnswerFromExcel('vehicleSecondaryClass', excelTrailerRow[trailerValueMapForVersion.SecondaryClass], this.dao);
            tempTrailer.vehicleTotalMilesUpto50.answer = isNaN(excelTrailerRow[trailerValueMapForVersion.TotalMilesUpto50]) ? "" : excelTrailerRow[trailerValueMapForVersion.TotalMilesUpto50];
            tempTrailer.vehicleTotalMilesUpto200.answer = isNaN(excelTrailerRow[trailerValueMapForVersion.TotalMilesUpto200]) ? "" : excelTrailerRow[trailerValueMapForVersion.TotalMilesUpto200];
            if(version == Constants.CurrentVehicleExcelTemplateVersion){
                tempTrailer.farthestApplicableZonePercent.answer = isNaN(excelTrailerRow[trailerValueMapForVersion.FarthestApplicableZonePercent]) ? "" : excelTrailerRow[trailerValueMapForVersion.FarthestApplicableZonePercent]; 
                if (!!tempTrailer.farthestApplicableZonePercent.answer && tempTrailer.farthestApplicableZonePercent.answer !== '0') {
                    tempTrailer.farthestToZone.answer = this.getValidDropdownAnswerFromExcel('farthestToZone', excelTrailerRow[trailerValueMapForVersion.FarthestToZone], this.dao); 
                }
                else {
                    tempTrailer.farthestToZone.answer = "";
                }
            }
            // 3rd form s
            const accounState = this.dao.DOTList.accountInfoQsnr.findQuestion("accountState")?.answer;
            if (accounState != 'MI') {
                tempTrailer.vehicleCompOTCCoverage.answer = this.getValidRadiobuttonAnswerFromExcel(excelTrailerRow[trailerValueMapForVersion.CompOTCCoverage]);
                tempTrailer.vehicleComp.answer = tempTrailer.vehicleCompOTCCoverage.answer == 'Yes' ? this.getValidDropdownAnswerFromExcel('vehicleComp', excelTrailerRow[trailerValueMapForVersion.Comp], this.dao) : "";
                tempTrailer.vehicleCollCoverage.answer = this.getValidRadiobuttonAnswerFromExcel(excelTrailerRow[trailerValueMapForVersion.CollCoverage]);
                tempTrailer.vehicleColl.answer = tempTrailer.vehicleCollCoverage.answer == 'Yes' ? this.getValidDropdownAnswerFromExcel('vehicleColl', excelTrailerRow[trailerValueMapForVersion.Coll], this.dao) : "";
                tempTrailer.floorTrailer.answer = tempTrailer.vehicleCollCoverage.answer == 'Yes' ? 'No' : "";
            }
            else {
                tempTrailer.vehicleCompOTCCoverage.answer = "";
                tempTrailer.vehicleCollCoverage.answer = "";
            }
            tempTrailer.vehicleStatedAmount.answer = isNaN(excelTrailerRow[trailerValueMapForVersion.StatedAmount]) ? "" : Math.round(excelTrailerRow[trailerValueMapForVersion.StatedAmount].trim());
            tempTrailer.vehicleCustomPartsParent.answer = this.getValidRadiobuttonAnswerFromExcel(excelTrailerRow[trailerValueMapForVersion.CustomParts]);
            tempTrailer.vehicleCustomAmount.answer = tempTrailer.vehicleCustomPartsParent.answer == 'Yes' ? (isNaN(excelTrailerRow[trailerValueMapForVersion.CustomAmount]) ? "" : Math.round(excelTrailerRow[trailerValueMapForVersion.CustomAmount].trim())) : "";
            tempTrailer.vehicleCustomDesc.answer = tempTrailer.vehicleCustomPartsParent.answer == 'Yes' ? excelTrailerRow[trailerValueMapForVersion.CustomDesc] : "";
            tempTrailer.vehicleAddInsuredOrLossPayee.answer = this.getValidRadiobuttonAnswerFromExcel(excelTrailerRow[trailerValueMapForVersion.AddInsuredOrLossPayee]);

            if (this.dao.vehicleModel.trailerList.length > 0 && this.dao.vehicleModel.trailerList.every(item => item.isChecked)) {
                tempTrailer.isChecked = true;
            }
            Object.keys(tempTrailer).forEach(tempKey => {
                if (typeof (tempTrailer[tempKey]) == 'object') {
                    tempTrailer[tempKey].group = 'TRA-' + (lastTrailerIndex + 1);
                    if (tempTrailer[tempKey].questionOptions != null && tempTrailer[tempKey].questionOptions.length > 0) {
                        tempTrailer[tempKey].questionOptions = []; //empty question options to reduce payload size
                    }
                }
            });
            tempTrailer.interestList = [];
            if (tempTrailer.vehicleAddInsuredOrLossPayee.answer == 'Yes') {
                var vehicleInsuredOrLossPayee = { 'Type': '', 'Name': '', 'streetAddress': '', 'city': '', 'state': '', 'zip': '', 'loanNo': '' };
                tempTrailer.interestList.push(vehicleInsuredOrLossPayee);
            }
            tempTrailer.vehicleType.answer = 'Unknown';
            this.dao.vehicleModel.trailerList.push(tempTrailer);
            this.dao.isTrailer = true;
        }
        return true; 
    }

    // validateTemplateVersion
    public validateTemplateVersion(uploadedExcelWorkBook: any): boolean {
        var uploadVersion = uploadedExcelWorkBook.Custprops['version'];
        return  (!!uploadVersion && uploadVersion == Constants.CurrentVehicleExcelTemplateVersion);
    }

    /// helper methods

    private getAndSetValidYear(year: string): string {
        if (!!!year) {
            return "";
        }
        year = year.trim();
        const isValidYear = /^\d{4}$/.test(year);
        if (isValidYear) {
            return year;
        }
        return "";
    }

    private getAndSetValidString(value: string): string {
        if (!!!value) {
            return "";
        }
        if (!this.userInputService.valueContainsNonAlphaNumericCharacters(value)) {
            return value.trim();
        }
        return "";
    }

    private getValidRadiobuttonAnswerFromExcel(value: string): string {
        if (!!!value) {
            return "";
        }
        value = value.toUpperCase().trim();
        if (value == 'YES') {
            return 'Yes';
        }
        if (value == 'NO') {
            return 'No';
        }
        return "";
    }

    private getValidDropdownAnswerFromExcel(key: string, value: string, dao: DAO): string {
        if (!!!value) {
            return "";
        }
        value = value.toUpperCase().trim().replace(/ /g, "").replace(",", "");
        if (dao.vehicleModel.vehicleDefault[key].questionOptions.some(x => x.label.toUpperCase().trim().replace(/ /g, "").replace(",", "") == value)) {
            return dao.vehicleModel.vehicleDefault[key].questionOptions.find(x => x.label.toUpperCase().trim().replace(/ /g, "").replace(",", "") == value).code;
        }
        return "";
    }
}